import React from 'react';
import { FormattedNumber } from 'react-intl';

import ProgressBar from '../../../../../../../components/ProgressBar';

import { comparativeUnits } from '..';

import './styles.css';
import ClientTable from './components/ClientTable';

function DashboardCompletedComparativeList({
  className,
  title,
  unit,
  data,
  customHeaders,
  showIndex,
  showDropdown,
  ...props
}) {
  const maxValue = Math.max(...data.map(d => d.value));

  const avg = data.reduce((sum, cur) => sum + cur.value, 0) / data.length;

  const getBarWidth = value => `${(value / maxValue) * 100}%`;

  const headers = showIndex ? [
    '#',
    'Estado',
    'Qtd. NF',
    'No prazo',
    'Atrasada',
    'Performance'
  ] : [
    'Estado',
    'Qtd. NF',
    'No prazo',
    'Atrasada',
    'Performance'
  ]

  const renderAvg = () => {
    const rightPos =
      unit === comparativeUnits.PERFORMANCE
        ? 100 - avg
        : (avg / maxValue) * 100


    return (
      <div 
        style={{
          display: 'flex',
          overflow: 'visible',
          flexDirection: 'column',
          alignItems: 'flex-start',
          position: 'absolute',
          top: -10,
          right: Number(-rightPos),
          marginRight: `${20 + rightPos}px`,
          zIndex: 1,
          bottom: 0,
          width: `${200 - rightPos}px`,
        }}
      >
        <div
          className="DashboardCompletedComparativeList__avg-text"
        >
          Média {formatValue(avg)}
        </div>
        <div
          className="DashboardCompletedComparativeList__avg-line"
        />
      </div>
    );
  };

  const renderBar = (value) => {
    if (unit === comparativeUnits.PERFORMANCE) {
      return <ProgressBar completed={value} />;
    }

    return (
      <div
        className="DashboardCompletedComparativeList__bar"
        style={{ width: getBarWidth(value) }}
      />
    );
  };

  const formatValue = (value) => {
    const prefix = unit === comparativeUnits.VALUE ? 'R$ ' : '';

    const sufix = {
      [comparativeUnits.PERFORMANCE]: '%',
      [comparativeUnits.WEIGHT]: 't',
      [comparativeUnits.VALUE]: 'm',
    }[unit];

    const fractionDigits = unit === comparativeUnits.PERFORMANCE ? 1 : 2;

    return [
      prefix,
      <FormattedNumber
        key="value"
        value={value}
        minimumFractionDigits={fractionDigits}
        maximumFractionDigits={fractionDigits}
      />,
      sufix,
    ];
  };

  return (
    <div
      className={`DashboardCompletedComparativeList ${className || ''}`}
      {...props}
    >
      {unit === comparativeUnits.PERFORMANCE ? (
        <ClientTable formatValue={formatValue} headers={customHeaders ? customHeaders : headers} data={[...data]} showIndex={showIndex} showDropdown={showDropdown} />
      ) : (
        <>
          
          <div className="DashboardCompletedComparativeList__item DashboardCompletedComparativeList__item__header">
            <div className="DashboardCompletedComparativeList__graph">
              {title || 'Estado'}
            </div>
            <div className="DashboardCompletedComparativeList__header_value">
              {
                {
                  [comparativeUnits.PERFORMANCE]: 'Performance',
                  [comparativeUnits.WEIGHT]: 'Peso',
                  [comparativeUnits.VALUE]: 'Valor',
                }[unit]
              }
            </div>
          </div>
          <div className="DashboardCompletedComparativeList__list-container">
            {[...data]
              .sort((a, b) => b.value - a.value)
              .map((item, i) => (
                <div className="DashboardCompletedComparativeList__item" key={i}>
                  <div className="DashboardCompletedComparativeList__text">
                    {item.text}
                  </div>
                  <div className="DashboardCompletedComparativeList__graph">
                    {renderBar(item.value)}
                  </div>
                  <div className="DashboardCompletedComparativeList__value">
                    {formatValue(item.value)}
                  </div>
                </div>
              ))}
              {renderAvg()}
          </div>
        </>
      )}
    </div>
  );
}

export default DashboardCompletedComparativeList;
